interface FogState {
    active: boolean;
    obscure: boolean;
}

const FogStore = {
    namespaced: true,
    state: {
        active: false,
        obscure: true,
    } as FogState,
    mutations: {
        toggleActive(state: FogState): void {
            state.active = !state.active;
        },
        setActive(state: FogState, value: boolean): void {
            state.active = value;
        },
        toggleObscure(state: FogState): void {
            state.obscure = !state.obscure;
        },
        setObscure(state: FogState, value: boolean): void {
            state.obscure = value;
        },
    },
};

export default FogStore;
